import { jwtDecode } from "jwt-decode";

const protectedRoutes: Record<
  string,
  (context: { auth: { isAuthenticated: boolean } }) => boolean
> = {
  "/applications/*": ({ auth }) => auth.isAuthenticated,
  "/docs/internal/*": ({ auth }) => auth.isAuthenticated,
  "/api-keys/*": ({ auth }) => auth.isAuthenticated,
};

type ProviderData = {
  accessToken: string;
};

export function hasAppStoreClaim(providerData: ProviderData): boolean {
  try {
    if (!providerData?.accessToken) return false;
    const decoded = jwtDecode(providerData.accessToken);

    for (const value of Object.values(decoded)) {
      if (Array.isArray(value)) {
        const hasClaim = value.some(
          (v) =>
            typeof v === "string" && v.toUpperCase().startsWith("APPSTORE_")
        );
        if (hasClaim) return true;
      }
    }
    return false;
  } catch {
    return false;
  }
}

export function isOpenGovEmail(providerData: ProviderData): boolean {
  try {
    if (!providerData?.accessToken) return false;
    const decoded = jwtDecode<{ email: string }>(providerData.accessToken);
    const email = decoded?.email;
    return typeof email === "string" && /@opengov\.com$/i.test(email);
  } catch {
    return false;
  }
}

export { protectedRoutes };
